var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.filter && _vm.badgeLabel)?_c('q-badge',{staticClass:"text-italic filter-mode-value-badge",attrs:{"label":_vm.badgeLabel,"outline":"","text-color":"primary"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }